import { Tooltip } from '@factorialco/deprecated-design-system'
import { F0Button } from '@factorialco/f0-react'
import { LockLocked, LockUnlocked } from '@factorialco/f0-react/icons/app'

import i18n from 'modules/core/lib/i18n'

type LockToggleButtonProps = {
  isClosed: boolean
  isLocked: boolean
  onToggle: () => void
  openLockTooltip: boolean
  toggleLockTooltip: (value: boolean) => () => void
}

function LockToggleButton({
  isClosed,
  isLocked,
  onToggle,
  openLockTooltip,
  toggleLockTooltip,
}: LockToggleButtonProps) {
  const lockPeriodText = i18n.t('compensations.PayrollRunCompensationsList.lock_period')
  const unlockPeriodText = i18n.t('compensations.PayrollRunCompensationsList.unlock_period')

  if (isClosed) {
    return (
      <Tooltip.Alt
        attachment="bottom center"
        open={openLockTooltip}
        toggle={toggleLockTooltip}
        label={i18n.t('compensations.PayrollRunCompensationsList.past_periods_cannot_be_unlocked')}
      >
        <F0Button onClick={onToggle} icon={LockLocked} variant="outline" disabled hideLabel />
      </Tooltip.Alt>
    )
  }

  return (
    <Tooltip.Alt
      attachment="bottom center"
      open={openLockTooltip}
      toggle={toggleLockTooltip}
      label={isLocked ? unlockPeriodText : lockPeriodText}
    >
      <F0Button
        onClick={onToggle}
        label={isLocked ? unlockPeriodText : lockPeriodText}
        hideLabel
        icon={isLocked ? LockLocked : LockUnlocked}
        variant="outline"
      />
    </Tooltip.Alt>
  )
}

export default LockToggleButton
